import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataJoinPoint, ApiNodeDataPlaceholder, GraphOperationResult } from '@onefootprint/request-types/dashboard';
import { Position } from '@xyflow/react';
import { motion } from 'framer-motion';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useEmployeeExperiments from '@/hooks/use-employee-experiments';
import useNodeContext from '../../hooks/use-node-context';
import useSidebar from '../../hooks/use-sidebar';
import useStore from '../../hooks/use-store';
import type { NodeProps } from '../../playbook-builder.types';
import AddButton from '../add-button';
import AddNodeDialog from '../add-node-dialog';
import CustomHandle from '../custom-handle';
import { LabelNode } from '../edge-label-node';
import RemoveButton from '../remove-button';
const PlaceholderNode = t0 => {
  const $ = _c(38);
  const {
    id,
    data
  } = t0;
  const [isHovered, setIsHovered] = useState(false);
  const {
    addAfterNodeOperations,
    removeOperation
  } = useNodeContext(id);
  const {
    onOperationComplete
  } = useSidebar();
  const [open, setOpen] = useState(false);
  const {
    t
  } = useTranslation("playbook-builder");
  const {
    data: t1
  } = useStore();
  const {
    canEdit
  } = t1;
  const isTerminalJoinPoint = !data.successor && data.kind === "join_point";
  let t2;
  if ($[0] !== onOperationComplete) {
    t2 = operation => {
      setOpen(false);
      onOperationComplete(operation);
    };
    $[0] = onOperationComplete;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClose = t2;
  const {
    isEnabled
  } = useEmployeeExperiments();
  let t3;
  if ($[2] !== isEnabled) {
    t3 = isEnabled("playbook-builder-debug-mode");
    $[2] = isEnabled;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const isDebugModeEnabled = t3;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsHovered(true);
    t5 = () => setIsHovered(false);
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] !== id) {
    t6 = <CustomHandle type="target" position={Position.Top} id={id} />;
    t7 = <CustomHandle type="source" position={Position.Top} id={id} />;
    $[6] = id;
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] !== addAfterNodeOperations.length) {
    t8 = addAfterNodeOperations.length > 0 && <AddButton onClick={() => setOpen(true)} />;
    $[9] = addAfterNodeOperations.length;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== canEdit || $[12] !== isDebugModeEnabled || $[13] !== isTerminalJoinPoint || $[14] !== t) {
    t9 = isTerminalJoinPoint && !canEdit && !isDebugModeEnabled && <LabelNode label={t(_temp)} />;
    $[11] = canEdit;
    $[12] = isDebugModeEnabled;
    $[13] = isTerminalJoinPoint;
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== canEdit || $[17] !== id || $[18] !== isDebugModeEnabled) {
    t10 = !canEdit && isDebugModeEnabled && <LabelNode label={id} />;
    $[16] = canEdit;
    $[17] = id;
    $[18] = isDebugModeEnabled;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== canEdit || $[21] !== data || $[22] !== isHovered || $[23] !== removeOperation) {
    t11 = removeOperation && canEdit && <motion.div initial={{
      opacity: 0,
      x: -8
    }} animate={{
      opacity: isHovered ? 1 : 0,
      x: isHovered ? 8 : -8
    }} transition={{
      duration: 0.1
    }} className="absolute -right-6"><RemoveButton operation={removeOperation} data={data} /></motion.div>;
    $[20] = canEdit;
    $[21] = data;
    $[22] = isHovered;
    $[23] = removeOperation;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== addAfterNodeOperations || $[26] !== data.subject || $[27] !== handleClose || $[28] !== open) {
    t12 = <Suspense fallback={null}><AddNodeDialog open={open} onClose={handleClose} operations={addAfterNodeOperations} subject={data.subject} /></Suspense>;
    $[25] = addAfterNodeOperations;
    $[26] = data.subject;
    $[27] = handleClose;
    $[28] = open;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t12 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8 || $[36] !== t9) {
    t13 = <div className="relative flex items-center justify-center w-[28px] h-[28px]" onMouseEnter={t4} onMouseLeave={t5}>{t6}{t7}{t8}{t9}{t10}{t11}{t12}</div>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};
export default PlaceholderNode;
function _temp($) {
  return $.placeholder.end;
}